<template>
  <el-dialog
    :visible.sync="visible"
    :title="title"
    :fullscreen="fullscreen"
    :show-close="showHeaderClose"
    :closeOnClickModal="closeOnClickModal"
    :width="width"
    v-bind="$attrs"
    top="5vh"
    :z-index="zIndex"
    @close="onClose"
    append-to-body
  >
    <template #header="{ close, titleId, titleClass }">
      <div class="my-header" style="display: flex; justify-content: space-between;">
        <div class="dy-dialog-title">{{ title }}</div>
        <div style="display: flex;">
          <full-screen
            style="width: 1em; height: 1em; margin-right: 8px;cursor:pointer"
            color="#909399"
            @click="fullscreen = !fullscreen"
          />
          <close style="width: 1em; height: 1em; margin-right: 8px;cursor:pointer" color="#909399" @click="onClose" />
        </div>
      </div>
    </template>
    <slot />
    <template v-if="showFooter" v-slot:footer>
      <slot name="footer">
        <el-button
          v-if="showConfirm"
          v-loading="loading"
          :disabled="loading"
          type="primary"
          icon="el-icon-check"
          @click="onConfirm"
        >{{ confirmTitle }}
        </el-button>
        <el-button icon="el-icon-close" @click="onClose">取 消</el-button>
      </slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'DyDialog',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    title: {
      type: String
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    showConfirm: {
      type: Boolean,
      default: true
    },
    closeOnClickModal: {
      type: Boolean,
      default: true
    },
    showHeaderClose: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '900px'
    },
    confirmTitle: {
      type: String,
      default: '保 存'
    },
    submitLoading: {
      type: Boolean,
      default: false
    },
    zIndex: {
      type: Number,
    }
  },
  data() {
    return {
      fullscreen: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    loading: {
      get() {
        return this.submitLoading
      }
    }
  },
  methods: {
    onClose() {
      this.visible = false
      this.$emit('onClose')
    },
    onConfirm() {
      this.$emit('onConfirm')
    }
  }
}
</script>

<style scoped>
.dy-dialog-title {
  font-size: 18px;
  font-weight: 500;
}


::v-deep {
  .el-dialog__header {
    border-bottom: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__footer {
    border-top: 1px solid rgba(236, 236, 236, 0.89);
  }
  .el-dialog__body {
    padding: 0 20px;
  }
}
</style>
